import React from "react";

class FieldHours extends React.Component {
    constructor(props) {
        super(props);

        _.map(["onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });

        this.inputRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if( this.inputRef.current ) {
            if(!_.isEqual(nextProps.hours, this.props.hours) && nextProps.hours === null) {
                this.inputRef.current.value = null;
            }

            if(!_.isEqual(nextProps.isUpdated, this.props.isUpdated) && nextProps.isUpdated) {
                this.inputRef.current.value = nextProps.hours;
            }

            if( parseInt( nextProps.hours ) < 0 ) {
                this.inputRef.current.value = 0;
            }
        }

        return true;
    }

    onChange(e) {
        if( this.props.onChange ) {
            this.props.onChange({ target: { id: "hours", value: e.target.value } });
        }
    }

    render() {
        if( this.props.type === 5 ) { 
            return (
                <input
                    id="hours"
                    type="number"
                    class="form-control"
                    defaultValue={ this.props.hours }
                    onChange={ this.onChange }
                    ref={ this.inputRef }
                />
            );
        }

        return (
            <span>{ this.props.hours }</span>
        )
    }
}

export default FieldHours;
